<header>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <a class="navbar-brand" href="#">تطبيق تجريبي</a>
    <button class="navbar-toggler d-lg-none" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarsExampleDefault">
      
        <ul *ngIf="status" class="navbar-nav mr-auto">
            <li class="nav-item">
               <a class="nav-link" (click)="logout()" href="#">تسجيل خروج</a>
            </li>
            <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard">الرئيسيو</a> 
            </li>   
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" routerLink="dashboard/posts">بيانات</a> 
              </li> 
                    
          </ul>

          <ul *ngIf="!status" class="nav navbar-nav">
              <li class="nav-item">
                <a class="nav-link" routerLinkActive="active" routerLink="/register"> تسجيل مستخدم جديد</a>
              </li>
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" routerLink="/login">تسجيل دخول</a>
            </li>
            
          </ul>
                     
    </div>
  </nav>
</header>
